// Locale/region configuration for vendor-portal — New Zealand build.
// Centralizes the market-specific strings (currency, business ID fields,
// address labels, phone format, map restriction) so a new market can be
// supported by swapping this file's values instead of touching every
// component that displays them.
const localeConfig = {
  intlLocale: 'en-NZ',
  timezone: 'Pacific/Auckland',
  currency: {
    code: 'NZD',
    symbol: '$',
  },
  address: {
    regionLabel: 'Region',
    postcodeLabel: 'Postcode',
    postcodePlaceholder: 'Enter postcode',
  },
  mobile: {
    // NZ mobiles are 8-9 national digits (021/022/027 + 6-8 digits, no leading
    // trunk 0) or 10 digits if the trunk 0 is kept, e.g. "0211234567".
    minDigits: 9,
    maxDigits: 10,
    placeholder: 'Enter mobile number',
    errorText: 'Please enter a valid mobile number',
  },
  businessId: {
    gstLabel: 'GST Number (IRD)',
    gstPlaceholder: 'Enter 8-9 digit GST/IRD number',
    // NZ has no PAN/Aadhar-equivalent vendor ID; NZBN could be added here later if required.
    showPan: false,
  },
  mapsCountryRestriction: 'nz',
};

export default localeConfig;
